<template lang="pug">
  div
    v-card(style="outline:2px solid #1976d2")
      v-card-title.pb-0 Pending Reservations
      v-card-subtitle.pt-4(v-if="pendingSessions.length > 0") Reservations are first come first serve. Submit reservations soon to lock in choices.
      v-list(v-if="pendingSessions.length > 0")
        v-list-item(v-for="session in pendingSessions" :key="session.id")
          v-list-item-content
            .overline.font-weight-bold.red--text.text--darken-2(v-if="!session.valid") No longer available
            .body-2.font-weight-bold {{session.facility.facility_name}}
            .body-2 {{session.space.name}} - {{session.breakoutName}}
            .body-2 {{session.slotString}}
          v-list-item-action
            v-btn(icon aria-label="remove pending session")
              v-icon(color='red' @click="remove(session.space.session_id)") mdi-close
      v-card-text.body-2(v-else) No Pending Reservations
      v-card-actions(v-if="pendingSessions.length > 0").d-flex.flex-column
        v-btn(v-if="(registrationGroup.timing_status != 'ON_TIME') && !(registrationGroup.timing_status == 'TOO_EARLY' && registrationGroup.isPriority)" disabled block) Registration Ended
        v-promise-btn.mx-0(
          v-else
          color="primary"
          @click="openTerms"
          block
          :disabled="!allSessionsValid"
          skipSuccess
        ) Submit Reservations
          template(v-slot:error) Unavailable Sessions
          template(v-slot:loader) Checking Availability
            v-progress-circular.ml-2(indeterminate)
    v-dialog(v-model="dialog" max-width=800)
      v-card.pt-4
        v-card-text(v-if="terms").body-1
          v-card#terms.overflow-y-auto(
            outline
            :height="$vuetify.breakpoint.height / 2"
          )
            v-card-text.body-1
              vue-markdown {{terms}}
          .d-flex.align-top.mt-6
            .body-1.mt-1 I,
            v-text-field.mx-4.mt-0.pt-0(
              v-model="signature"
              messages="Read all terms and conditions and type your full name to confirm."
            )
            .body-1.mt-1 have read and accepted these terms and conditions.
        v-card-actions
          v-btn(v-if="(registrationGroup.timing_status != 'ON_TIME') && !(registrationGroup.timing_status == 'TOO_EARLY' && registrationGroup.isPriority)" disabled block) Registration Ended
          v-promise-btn(v-else color="primary" :disabled="!formValid" @click="submit" skipSuccess) Submit
</template>

<script>
import VueMarkdown from 'vue-markdown'
import { mapState, mapGetters } from 'vuex'
import VPromiseBtn from '@/components/VPromiseBtn'

export default {
  components: {
    VPromiseBtn,
    VueMarkdown
  },
  data: () => ({
    dialog: false,
    terms: null,
    signature: ''
  }),
  computed: {
    ...mapState({
      fullname: state => state.main.coach.name,
      pendingSessions: state => state.main.pendingSessions
    }),
    ...mapGetters(['season', 'registrationGroup']),
    allSessionsValid() {
      return !this.pendingSessions.some(s => !s.valid)
    },
    formValid() {
      return this.signature.length
    }
  },
  methods: {
    remove (id) {
      this.$store.commit('removePendingSession', id)
      this.$store.dispatch('refresh')
    },
    async openTerms() {
      await this.$store.dispatch('refresh')
      if(this.allSessionsValid){
        this.confirmCheckbox = false
        this.dialog = true
        this.signature = ''
        let termsElement = document.getElementById('terms')
        if(termsElement)
          termsElement.scrollTop = 0
      }
    },
    async submit() {
      await this.$store.dispatch('submitReservations')
      this.dialog = false
    }
  },
  async mounted() {
    let response = await fetch('https://strapi.arlingtonva.us/terms-and-conditions?slug=gym-reservation')
    let json = await response.json()
    this.terms = json[0].terms
  }
}
</script>